if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.requestVersion = 0;
        this.errorHtml =
          this.querySelector("template")?.content.firstElementChild?.cloneNode(
            true,
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        if (this.hasAttribute("available")) {
          this.fetchAvailability(this.dataset.variantId);
        }
      }

      disconnectedCallback() {
        this.invalidateAvailability();
      }

      invalidateAvailability() {
        this.requestVersion++;
        this.abortController?.abort();
        this.abortController = null;
        this.drawer?.remove();
        this.drawer = null;
        this.removeAttribute("available");
        this.innerHTML = "";
      }

      fetchAvailability(variantId) {
        if (!variantId) return;
        this.invalidateAvailability();
        this.dataset.variantId = String(variantId);
        const requestVersion = this.requestVersion;
        const controller = new AbortController();
        this.abortController = controller;
        const isCurrent = () =>
          this.isConnected && requestVersion === this.requestVersion;

        let rootUrl = this.dataset.rootUrl || "/";
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl, { signal: controller.signal })
          .then((response) => {
            if (!response.ok)
              throw new Error("Pickup availability request failed");
            return response.text();
          })
          .then((text) => {
            if (!isCurrent()) return;
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            if (!sectionInnerHTML)
              throw new Error("Pickup availability response is incomplete");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((error) => {
            if (error.name === "AbortError" || !isCurrent()) return;
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.removeAttribute("available");
        if (!this.errorHtml) return;
        this.appendChild(this.errorHtml.cloneNode(true));
        this.querySelector("button")?.addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) {
          drawer.remove();
        }

        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        ).outerHTML;
        this.setAttribute("available", "");

        this.drawer = sectionInnerHTML.querySelector(
          "pickup-availability-drawer",
        );
        if (this.drawer) document.body.appendChild(this.drawer);
      }
    },
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  class PickupAvailabilityDrawer extends DrawerModal {
    constructor() {
      super();
    }
  }

  customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
}
